/**
 * wql
 * @description 审批作业
 * @Date  2020/10/31
 */
import React from "react";
import {connect} from "dva";
import {templateConfig, reduxTemplateCofig} from "./reviewConfig";
import {downLoadBiz} from '@/utils'

import {component_tool, framework_tool, utils_tool} from '../../../tool';
import { Base64 } from "js-base64";
import CryptoJS from 'crypto-js'

let {Session} = utils_tool;

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {WizBrowserExport, Wizmessage} = component_tool;

class HomeworkRecordReviewList extends WizContainer {
  componentName = 'homeworkRecordReviewList';

  constructor(props) {
    super(props);
    let {history} = props
    let recordInfo = {}
    if (history.location && history.location.pathname && history.location.pathname.endsWith('/homeworkRecordReviewJump')) {
      if (history.location && history.location.record) {
        recordInfo = history.location.record
        Session.set('recordInfo', recordInfo)
      } else {
        recordInfo = Session.get('recordInfo') || {}
      }
    }
    this.state = {
      labelAll: [],
      recordInfo: recordInfo,
    };
    this.record = {}
  }

  _componentDidMount() {
    this.doActions([
      {
        path: 'contentLabel/export',
        payload: {
          key: 'contentLabel@export',
          apiParams: {type: 12} //作业标签
        }
      },
    ])
  }

  propsAndStateOnChange = {
    contentLabelList: this._getContentLabelListOver.bind(this),
  }

  _getContentLabelListOver(nextProps, nextState) {
    if (nextProps.contentLabelList.code == 1 && nextProps.contentLabelList.data) {
      let labelAll = nextProps.contentLabelList.data;
      nextState.labelAll = labelAll
    } else {
      wizNotice.error(nextProps.contentLabelList.msg);
    }
    return true;
  }


  /**
   * 批量下载
   * @param {*} nextProps
   * @param {*} nextState
   * @param {*} key
   */
  _download(nextProps, nextState, key) {
    let {success, data, msg} = nextProps[key]
    if (success && data) {
      let {recordImgList, recordVideoList, recordAudioList, recordFileList} = data;
      let downloads = [
        ...(recordImgList || []),
        ...(recordVideoList || []),
        ...(recordAudioList || []),
        ...(recordFileList || []),
      ]
      if (downloads.length) {
        let d = downloads.map(({fileId, fileName, fileMimeType, fileSize, fileUri}) => {
          return {
            "code": fileId,
            "bizCode": fileId,
            //"category": "car_price",
            "kname": fileName,
            "vname": fileName,
            //"attachType": "链接",
            "url": getOssFilePath(fileId)//ossFileUtils.getOssFile(fileId, fileName, fileMimeType, fileSize, fileUri,)
          }
        })
        downLoadBiz(data.fullName+'（'+data.userName+'）'+data['homeworkInfo']['name'], d)
      } else {
        Wizmessage.warning('该作业未上传附件')
      }
    } else {
      wizNotice.error(msg || '获取文件信息失败,请稍后再试')
      return false;
    }
    return true;
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

   encrypt(message, key) {  
    const keyLength = key.length;  
    const messageChunks = [];  
    let encryptedChunks = [];  
  
    while (message.length > 0) {  
        const chunk = message.substring(0, keyLength);  
        message = message.substring(keyLength);  
        messageChunks.push(chunk);  
    }  
  
    for (let i = 0; i < messageChunks.length; i++) {  
        const encryptedChunk = CryptoJS.AES.encrypt(messageChunks[i], key).toString();  
        encryptedChunks.push(encryptedChunk);  
    }  
  
    return encryptedChunks;  
  }

  checkHandler(nextProps, nextState, key) {
    let o = nextProps[key]
    console.log("sss::",nextState)
    if (o['success']) {
      // 加密 
      let secretKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAIhQbAwQZcepbCLD3Y0nNUPLh6JN44K'
      let jsonData = nextProps.apis.check?.payload?.apiParams.filters
      const encodeParams = CryptoJS.AES.encrypt(JSON.stringify(jsonData), secretKey);  
      let encryptedData = encodeParams.toString()
      let id = o.data;
      let url = location.origin + '/#/homeworkRecord/homeworkRecordAudit?params='+encryptedData+'&id=' + id
      window.open(url, '_blank');
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _export(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let column = [
        {
          headerName: "标题",
          field: "name",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "标题",
          field: "name",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "提交人姓名",
          field: "fullName",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "提交人账号",
          field: "userName",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "提交时间",
          field: "submitTime",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "组织名称",
          field: "orgName",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "组织编码",
          field: "orgCode",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "岗位",
          field: "positionName",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "是否通过",
          field: "pass",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          }
        },
        {
          headerName: "标签",
          field: "labelIds",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "状态",
          field: "state",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "成绩",
          field: "score",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "评分人",
          field: "reviewerName",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "当前评分人",
          field: "currentReviewerName",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        }
      ]
      let dataList = o.data
      dataList.forEach(e => {
        if (e.state == 0) {
          e.state = '未提交'
        } else if (e.state == 1) {
          e.state = '已提交'
        } else if (e.state == 2) {
          e.state = '已批阅'
        }
        if (e.pass === 0) {
          e.pass = '未通过'
        } else if (e.pass === 1) {
          e.pass = '通过'
        } else {
          e.pass = ""
        }
      })
      WizBrowserExport({
        title: '作业记录',
        sheetName: '作业记录',
        columns: column.filter((_, index) => index),
        rows: dataList,
        filename: '作业记录.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _componentWillMount() {
    const {history} = this.props
    if (history.location && history.location.pathname === '/homework/homeworkRecordList') {//直接进来
      return;
    }
    let record = this.props.location.record;
    if (record) {
      Session.set('homeworkInfo', record);
      this.record = record;
    }
    if (Session.get('homeworkInfo')) {
      this.record = Session.get('homeworkInfo');
    }
  }

  _handleAuditCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      this.changeModal(false, true, true)
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let entityId = this.record.id;
    let {labelAll, recordInfo} = this.state
    let _reduxTemplateConfig = reduxTemplateCofig({
      templateConfig: templateConfig({entityId, _this: this,labelAll:labelAll,recordInfo}),
      apiDataFormat: {
        enable: this._handleCMD,
        export: this._export,
        getPathContent: this._getPathContent,
        updateState: this._handleCMD,
        del: this._handleCMD,
        check: this.checkHandler,
        getInfo: this._download,
        batchAudit: this._handleAuditCMD.bind(this),
      },
      entityId: entityId,
      recordInfo: recordInfo
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const  {contentLabel} = state
  const contentLabelList = modelUtils.getModelEntity(contentLabel,'contentLabel@export');
  const load = modelUtils.getLoadingState(state, 'contentLabel');
  return {
    contentLabelList,
    ...load
  }
};

export default connect(mapStateToProps)(HomeworkRecordReviewList);